type RuntimeEnv = "dev" | "prod";

export const getRuntimeEnv = (): RuntimeEnv => {
  const { hostname } = window.location;

  // Local development
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "dev";
  }

  // Explicit domains
  if (hostname === "warehouse-admin.dev.syncrosale.com") return "dev";
  if (hostname === "warehouse-admin.syncrosale.com/") return "prod";

  // Fallbacks (preview / custom subdomains)
  if (hostname.includes("dev")) return "dev";

  return "prod";
};
